<p-galleria
  [(activeIndex)]="activeIndex"
  [(visible)]="displayFullScreenGalleria"
  [circular]="true"
  [fullScreen]="true"
  [showItemNavigators]="true"
  [showThumbnails]="false"
  [value]="files()">
  <ng-template
    #item
    let-item>
    <div class="aspect-[16/9] w-[80vw]">
      @if (fetchMultimediaDetails(item.id) | async; as multimedia) {
        <app-image-thumbnail size="full">
          <img
            [alt]="multimedia.alt"
            [ngSrc]="multimedia.previewUrl"
            [fill]="true"
            class="object-contain" />
        </app-image-thumbnail>
      } @else {
        <app-spinner-filled />
      }
    </div>
  </ng-template>
</p-galleria>
